import { all, takeLatest } from 'redux-saga/effects';

import { UploadFile } from './features/upload-file/upload-file';

export function* fileSagas() {
  yield all([takeLatest(UploadFile.action, UploadFile.saga)]);
}
